import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import styles from "./SchedulingUpsell.module.css";

/**
 * Bloqueio gracioso das telas de AGENDA para tenants do Plano Atendimento
 * (`plan.schedulingIncluded === false` — ADR-0026).
 *
 * BLOQUEAR, NÃO ESCONDER: o ADR §Decisão é explícito — esconder as telas mata a
 * descoberta, que é o único motor de upgrade deste tier. Por isso a rota
 * continua existindo, o item continua no menu (com cadeado) e a tela renderiza
 * ESTE convite no lugar do conteúdo.
 *
 * Reuso: nasce como cópia deliberada do visual de
 * `pages/FollowUp/components/PlanGate` (mesmos tokens, mesma linguagem). Aquele
 * componente é local da tela de Follow-up e tem copy fixa do plano Avançado —
 * não dá para reusar sem torná-lo genérico e mexer na tela dele. Este vive em
 * `components/` porque é compartilhado por 8 rotas.
 *
 * Nunca exibe erro técnico: é um convite, não uma falha.
 */
export default function SchedulingUpsell({
  upgradeUrl = "/subscription/plans",
  title = "Agendamento não faz parte do seu plano",
  description = "No Plano Atendimento o assistente responde dúvidas, informa preços e captura contatos — mas não marca horários.",
}) {
  return (
    <div className={styles.wrapper}>
      <section className={styles.gate} aria-label="Agendamento indisponível no plano atual">
        <span className={styles.lock} aria-hidden="true">
          🔒
        </span>
        <h2 className={styles.title}>{title}</h2>
        <p className={styles.text}>{description}</p>
        <p className={styles.text}>
          Faça upgrade para liberar agenda, profissionais, expedientes,
          bloqueios e lista de espera.
        </p>
        <div className={styles.actions}>
          <Link to={upgradeUrl} className={styles.btnPrimary}>
            Ver planos
          </Link>
          <Link to="/business/support" className={styles.btnSecondary}>
            Falar com suporte
          </Link>
        </div>
        <p className={styles.footnote}>
          Seus <Link to="/business/services">serviços e preços</Link> e as{" "}
          <Link to="/business/settings">perguntas frequentes</Link> continuam
          liberados — é por ali que o assistente responde seus clientes.
        </p>
      </section>
    </div>
  );
}

SchedulingUpsell.propTypes = {
  upgradeUrl: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
};

/**
 * Variante compacta, para usar INLINE dentro de uma tela que continua liberada
 * mas tem um bloco só-de-agenda (ex.: "Lembrete de Reativação" em
 * /business/settings, cuja rota `PATCH /tenants/reminder-settings` é gateada
 * pelo backend). Mesma linguagem, sem ocupar a tela inteira.
 */
export function SchedulingUpsellInline({
  upgradeUrl = "/subscription/plans",
  message = "Este recurso depende da agenda e não faz parte do Plano Atendimento.",
}) {
  return (
    <div className={styles.inline} role="note">
      <span className={styles.inlineLock} aria-hidden="true">
        🔒
      </span>
      <p className={styles.inlineText}>{message}</p>
      <Link to={upgradeUrl} className={styles.inlineCta}>
        Ver planos
      </Link>
    </div>
  );
}

SchedulingUpsellInline.propTypes = {
  upgradeUrl: PropTypes.string,
  message: PropTypes.string,
};
